export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem('userAdmin')) || JSON.parse(sessionStorage.getItem('userAdmin')) || null,
    token: localStorage.getItem('tokenJWTWeb') || sessionStorage.getItem('tokenJWTWeb') || null,
    refresh: localStorage.getItem('refreshJWTWeb') || sessionStorage.getItem('refreshJWTWeb') || null,
  },
  getters: {
    user (state) {
      return state.user
    },
    name (state) {
      return state.user != null ? state.user.name : ''
    },
    logado (state) {
      return state.user != null
    },
  },
  actions: {
    login ({ commit }, credenciais) {
      const { email, password, keepLoggedIn } = credenciais
      return new Promise((resolve, reject) => {
        this._vm.$axios.post(
          '/token/login',
          {
            email,
            password,
          },
        )
          .then(response => {
            const { id, email, name, role, token, refresh } = response.data
            const jToken = this._vm.$CryptoJS.AES.encrypt(
              token,
              process.env.VUE_APP_CRYPTO_PASS,
            ).toString()
            const jRefresh = this._vm.$CryptoJS.AES.encrypt(
              refresh,
              process.env.VUE_APP_CRYPTO_PASS,
            ).toString()
            commit('destruirUser')
            commit('destruirToken')
            commit('destruirRefresh')
            commit('recuperarUser', { id, email, name, role, keep: keepLoggedIn })
            commit('recuperarToken', { token: jToken, keep: keepLoggedIn })
            commit('recuperarRefresh', { refresh: jRefresh, keep: keepLoggedIn })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$axios.post(
          '/token/logout',
        )
          .then(response => {
            commit('destruirUser')
            commit('destruirToken')
            commit('destruirRefresh')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateUser ({ state, commit }, credenciais) {
      commit('recuperarUser', { ...state.user, ...credenciais })
    },
  },
  mutations: {
    recuperarUser (state, user) {
      if (user.keep) {
        localStorage.setItem('userAdmin', JSON.stringify(user))
      } else {
        sessionStorage.setItem('userAdmin', JSON.stringify(user))
      }
      state.user = user
    },
    destruirUser (state) {
      if (Object.keys(localStorage).includes('userAdmin')) {
        localStorage.removeItem('userAdmin')
      } else if (Object.keys(sessionStorage).includes('userAdmin')) {
        sessionStorage.removeItem('userAdmin')
      }
      state.user = null
    },
    recuperarToken (state, value) {
      if (value.keep) {
        localStorage.setItem('tokenJWTWeb', value.token)
      } else {
        sessionStorage.setItem('tokenJWTWeb', value.token)
      }
      state.token = value.token
    },
    recuperarRefresh (state, value) {
      if (value.keep) {
        localStorage.setItem('refreshJWTWeb', value.refresh)
      } else {
        sessionStorage.setItem('refreshJWTWeb', value.refresh)
      }
      state.refresh = value.refresh
    },
    destruirToken (state) {
      if (Object.keys(localStorage).includes('tokenJWTWeb')) {
        localStorage.removeItem('tokenJWTWeb')
      } else if (Object.keys(sessionStorage).includes('tokenJWTWeb')) {
        sessionStorage.removeItem('tokenJWTWeb')
      }
      state.token = null
    },
    destruirRefresh (state) {
      if (Object.keys(localStorage).includes('refreshJWTWeb')) {
        localStorage.removeItem('refreshJWTWeb')
      } else if (Object.keys(sessionStorage).includes('refreshJWTWeb')) {
        sessionStorage.removeItem('refreshJWTWeb')
      }
      state.refresh = null
    },
  },
}
